module.exports = __webpack_public_path__ + "img/availableColors@2x.d904af6.jpg";